import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="bg-white max-w-3xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-6">
        {t("privacyPolicy.title")}
      </h1>

      <section className="prose prose-gray max-w-none">
        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.responsible.title")}</h2>
        <p>{t("privacyPolicy.responsible.intro")}</p>
        <ul className="list-disc ml-6 space-y-1">
          <li><strong>{t("privacyPolicy.responsible.name")}:</strong> MexaBeer</li>
          <li><strong>{t("privacyPolicy.responsible.email")}:</strong> privacidad@mexabeer.com</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.dataCollected.title")}</h2>
        <p>{t("privacyPolicy.dataCollected.intro")}</p>
        <ul className="list-disc ml-6 space-y-1">
          {t("privacyPolicy.dataCollected.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.purpose.title")}</h2>
        <p>{t("privacyPolicy.purpose.intro")}</p>
        <ul className="list-disc ml-6 space-y-1">
          {t("privacyPolicy.purpose.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.arcorights.title")}</h2>
        <p>{t("privacyPolicy.arcorights.intro")}</p>
        <p>{t("privacyPolicy.arcorights.description")}</p>
        <ul className="list-disc ml-6 space-y-1">
          {t("privacyPolicy.arcorights.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.transfers.title")}</h2>
        <p>{t("privacyPolicy.transfers.intro")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.cookies.title")}</h2>
        <p>{t("privacyPolicy.cookies.intro")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.security.title")}</h2>
        <p>{t("privacyPolicy.security.intro")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.changes.title")}</h2>
        <p>{t("privacyPolicy.changes.intro")}</p>

        <h2 className="text-xl font-semibold mt-8">{t("privacyPolicy.contact.title")}</h2>
        <p>{t("privacyPolicy.contact.intro")}</p>
        <p>
          <a href="mailto:privacidad@mexabeer.com" className="text-indigo-600 hover:text-indigo-800 font-medium">
            privacidad@mexabeer.com
          </a>
        </p>

        <div className="mt-12">
          <Link
            to="/"
            className="inline-flex items-center rounded-md bg-orange-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-orange-700"
          >
            {t("privacyPolicy.backHome")}
          </Link>
        </div>
      </section>
    </div>
  );
}